exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../node_modules/postcss-loader/index.js!../index2.css"), undefined);

// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"layout": "_-_-src-containers-___food__layout___2PeW6 " + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../node_modules/postcss-loader/index.js!../index2.css").locals["layout"] + "",
	"entryInner": "_-_-src-containers-___food__entryInner___29F7y " + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!../../node_modules/postcss-loader/index.js!../index2.css").locals["entry__inner"] + ""
};


//////////////////
// WEBPACK FOOTER
// /var/www/build-lk-1/~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!/var/www/build-lk-1/~/postcss-loader!/var/www/build-lk-1/src/containers/food.css
// module id = 1215
// module chunks = 0